import React from 'react';
import { ChevronLeft, ChevronRight, Download, Eye, EyeOff } from 'lucide-react';

interface FinanceHeaderProps {
  showValues: boolean;
  onToggleValues: () => void;
  selectedDate: { month: number; year: number };
  onNavigateMonth: (direction: 'prev' | 'next') => void;
}

export const FinanceHeader: React.FC<FinanceHeaderProps> = ({
  showValues,
  onToggleValues,
  selectedDate,
  onNavigateMonth
}) => {
  const formatMonthYear = (month: number, year: number) => {
    const date = new Date(year, month - 1);
    return date.toLocaleDateString('pt-BR', { month: 'long', year: 'numeric' });
  };

  return (
    <div className="flex items-center justify-between mb-8">
      <div className="flex items-center gap-4">
        <h2 className="text-2xl font-bold">Financeiro</h2>
        <div className="h-6 w-px bg-white/10" />
        <div className="flex items-center gap-2 bg-[#111]/80 rounded-lg p-2">
          <button
            onClick={() => onNavigateMonth('prev')}
            className="p-1 hover:bg-white/10 rounded-md transition-colors"
          >
            <ChevronLeft size={20} />
          </button>
          
          <span className="px-3 text-sm font-medium">
            {formatMonthYear(selectedDate.month, selectedDate.year)}
          </span>
          
          <button
            onClick={() => onNavigateMonth('next')}
            className="p-1 hover:bg-white/10 rounded-md transition-colors"
          >
            <ChevronRight size={20} />
          </button>
        </div>
      </div>

      <div className="flex items-center gap-3">
        <button
          onClick={onToggleValues}
          className="flex items-center gap-2 px-4 py-2 rounded-lg bg-[#111]/80 hover:bg-[#222]/80 transition-colors"
        >
          {showValues ? <EyeOff size={18} /> : <Eye size={18} />}
          <span className="text-sm">{showValues ? 'Ocultar valores' : 'Mostrar valores'}</span>
        </button>

        <button className="flex items-center gap-2 px-4 py-2 rounded-lg bg-[#111]/80 hover:bg-[#222]/80 transition-colors">
          <Download size={18} />
          <span className="text-sm">Exportar</span>
        </button>
      </div>
    </div>
  );
};
